import { lazy, StrictMode, Suspense, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { AccountProvider, useAccount } from "./account/AccountProvider";
import { Toast } from "./account/Toast";
import { applyBackground, readStore } from "@hachi/api";
import { trackPage } from "./account/track";
import { watchErrors } from "./account/report";
import { store } from "./account/backend";
import "./styles/tokens.css";
import "./styles/base.css";

watchErrors();
applyBackground(readStore(store).theme?.bg); // the last background the admin chose, before the first paint

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");

// Downloaded when needed: someone signed in never loads the sign-in screens, and the reverse.
const App = lazy(() => import("./app/App"));
const Gate = lazy(() => import("./account/Gate").then((m) => ({ default: m.Gate })));

/** The app once this device may open it; a sign-in or account screen until then. */
function AppOrGate() {
  const { view } = useAccount();
  useEffect(() => { if (view.view !== "app") trackPage("/app/signin"); }, [view.view]);
  return (
    <>
      <Suspense fallback={null}>{view.view === "app" ? <App /> : <Gate view={view} />}</Suspense>
      <Toast />
    </>
  );
}

createRoot(root).render(
  <StrictMode>
    <AccountProvider>
      <AppOrGate />
    </AccountProvider>
  </StrictMode>,
);
